import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PRICE_ORACLE_ADDRESSES } from '../constants';
export var GetAssetPrice = createPlugin({
    protocol: 'RADIANTV2',
    type: 'ORACLE',
    method: 'getAssetPrice',
    supportedContracts: PRICE_ORACLE_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    asset: new FctAddress({ options: getRadiantV2Tokens({ chainId: chainId }) }),
                },
            },
            output: {
                price: new FctValue18({ innerIndex: 0 }),
            },
        });
    },
});
